var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-rid":`${_vm.payload.blockid}-${_vm.payload.page}`}},[_c('div',{attrs:{"id":`yandex_rtb_${_vm.payload.blockid}-${_vm.payload.page}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }